<template>
    <div v-if="user && infoFetched">
        <div class="card mb-3">
            <div class="card-body">
                <h5 class="card-title">{{ user.user_name }}</h5>
                <p class="card-text">{{ user.email }}</p>
                <div class="row">
                    <p class="card-text">{{ capitalize($t('groups_exact')) }}</p>
                    <textarea readonly class="form-control scrollable-textarea" rows="6"
                        v-model="groupsText"></textarea>
                </div>

            </div>
        </div>
    </div>
    <div v-else>
        <div class="card mb-3">
            <div class="card-body">
                <p class="card-text">{{ $t('select_to_see_info') }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import { capitalize } from '@/helpers';
import { fetchData } from '@/helpers';

export default {
    name: 'UserCard',
    props: {
        user: {
            type: Object,
            required: true,
            default: () => ({})
        },
    },
    computed: {
        groupsText() {
            return this.groups && Array.isArray(this.groups) ? this.groups.map(group => group.group_name).join('\n') : '';
        }
    },
    data() {
        return {
            groups: [],
            infoFetched: false
        }
    },
    watch: {
        user: {
            immediate: true,
            async handler(newUser) {
                if (newUser && newUser.user_id) {
                    const groups = await this.fetchData('usergroups', {"user_id": newUser.user_id});
                    //console.log(groups);
                    if (groups) {
                        this.groups = groups;
                    }
                    this.infoFetched = true;
                }
            }
        },
        key: {
            async handler() {
                //console.log('Key changed:', newVal);
                const groups = await this.fetchData('usergroups', {"user_id": this.user.user_id});
                    //console.log(groups);
                    if (groups) {
                        this.groups = groups;
                    }
        }
    }
    },
    methods: {
        fetchData,
        capitalize
    }
}
</script>

<style scoped>
.scrollable-textarea {
    resize: none;
    /* Disable resizing */
    overflow-y: auto;
    /* Enable vertical scrolling */
}
</style>